import { Component, inject, Input } from '@angular/core';
import { LanguageService } from '../../../Shared/language.service';
import { TranslatePipe } from '../../../Pipes/translate-pipe';

/**
 * English | Español switch for public pages (onboarding, referral).
 * Uses the shared LanguageService, so it stays in sync with the portal's Settings language.
 */
@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './language-switch.html',
  styleUrl: './language-switch.scss',
})
export class LanguageSwitch {
  /** Page prefix for element ids, e.g. 'po' → po__langen / po__langes */
  @Input() idPrefix = 'ls';

  language = inject(LanguageService);
}
